import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import { nav } from '../nav'

export default function LandingPage() {
  return (
    <>
      <SeoHead
        frontmatter={{
          title: 'Chosen Help',
          description:
            'Guides and how-tos for the Chosen applicant tracking system. Find, schedule, and hire candidates without rage-quitting your spreadsheets.',
          category: 'landing',
          keywords: [
            'Chosen ATS',
            'applicant tracking system help',
            'recruiting software docs',
          ],
        }}
        path="/"
        ogType="website"
      />
      <header className="landing-hero">
        <h1 className="landing-title">Chosen Help</h1>
        <p className="landing-lede">
          Guides and how-tos for the people who actually have to use the
          product. New here? Start with{' '}
          <Link to="/getting-started">Getting started</Link>.
        </p>
      </header>

      {nav.map((section) => (
        <section key={section.title}>
          <h2 className="card-group-title">{section.title}</h2>
          <div className="card-grid">
            {section.items.map((leaf) => (
              <Link key={leaf.slug} to={leaf.slug} className="card">
                <p className="card-title">{leaf.title}</p>
                <p className="card-body">{leaf.description}</p>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </>
  )
}
